import { querySelector, querySelectorId } from '../functions/querySelectors';
import debounce from '../functions/debounce';
import { PAGING_CLASS, PAGING_START_CLASS, PAGING_NO_SHADOW_CLASS } from '../scripts/paging2';

const NOTIFICATION_LINE_CLASS = 'js-cookie-bar';
const CHAT_ID = 'supportBox-iframe';
const TRUSTED_SHOP_CLASS = 'w-trusted-budge';
const STICKY_MOVING_INIT_CLASS = 'sm-init';
const PAGING_HEIGHT = 46;

let notificationElement = null;
let pagingElement = null;

export function getNotificationSize() {
  if (!notificationElement) {
    notificationElement = querySelector(`.${NOTIFICATION_LINE_CLASS}`);
  }

  if (notificationElement) {
    return parseInt(notificationElement.getBoundingClientRect().height, 10);
  }

  return 0;
}

let isPagingActive = function() {
  if (pagingElement) {
    return !pagingElement.classList.contains(PAGING_START_CLASS) && !pagingElement.classList.contains(PAGING_NO_SHADOW_CLASS);
  }

  return false;
};

let setPosition = function(nSize = null) {
  let notificationSize = 0;
  let pagingSize = 0;

  if (nSize === null) {
    notificationSize = getNotificationSize();
  }

  if (isPagingActive()) {
    pagingSize = PAGING_HEIGHT;
    setPagingPosition(`${notificationSize}px`);
  }

  setChatPosition(`${notificationSize + pagingSize}px`);
  setTrustedShopPosition(`${notificationSize + pagingSize}px`);
};

let setChatPosition = function(position) {
  let chat = querySelectorId(CHAT_ID);

  if (chat) {
    chat.style.removeProperty('transition');
    chat.style.marginBottom = position;
  }
  else {
    setTimeout(() => {
      setChatPosition(position);
    }, 250);
  }
};

let setTrustedShopPosition = function(position) {
  let trustedShop = querySelector(`.${TRUSTED_SHOP_CLASS}`);

  if (trustedShop) {
    trustedShop.style.marginBottom = position;
  }
};

let setPagingPosition = function(position) {
  pagingElement.style.bottom = position;
};

let windowResize = function(event) {
  setPosition();
};

let windowScroll = function(event) {
  setPosition();
};

export function recountFooter(notificationSize = null) {
  setPosition(notificationSize);
};

export function initFooter() {
  if (!document.body.classList.contains(STICKY_MOVING_INIT_CLASS)) {
    notificationElement = querySelector(`.${NOTIFICATION_LINE_CLASS}`);
    pagingElement = querySelector(`.${PAGING_CLASS}`);

    document.body.classList.add(STICKY_MOVING_INIT_CLASS);
    window.addEventListener('resize', debounce(windowResize, 250));

    if (pagingElement) {
      window.addEventListener('scroll', debounce(windowScroll, 250));
    }
  }
}
